import { SaleOrderProduct } from 'models/sale-order';
import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Form from 'react-bootstrap/Form'
import { TransportForm } from './SaleOrderTransportForm';

export interface SaleOrderFuelTableProps {
  form: TransportForm;
  items: SaleOrderProduct[];
  toggleItem: (item: SaleOrderProduct) => void;
  changeVolume: (item: SaleOrderProduct, volume?: number) => void;
}

export default function SaleOrderFuelTable(props: SaleOrderFuelTableProps) {

  const changeVolume = (item: SaleOrderProduct, volume?: string): void => {
    props.changeVolume(item, isNaN(parseFloat(volume || '')) ? undefined : parseFloat(volume as string));
  }

  return (
    <div className='d-flex flex-column'>
      <div className='d-flex justify-content-between px-3 py-2'>
        <span>KAUP</span>
        <span className='text-right'>
          KOGUS<br />
          <i className="icon--16 icon__info--masked bg-dark d-inline-block mr-1"></i>
          <small>Vähim kogus 1000 L, koguse samm 100 L</small>
        </span>
      </div>
      <div className='d-flex flex-column px-3 mx-n3 py-2' style={{
        maxHeight: '70vh',
        overflowY: 'auto'
      }}>
        {
          props.items.map((item, i) => (
            <div className='card border d-flex flex-row justify-content-between align-items-center px-4 py-3' key={'item_' + i}>
              <div className='d-flex flex-column'>
                <Form.Check
                  id={'check-' + item.productId}
                  custom
                  type="checkbox"
                  label={item.exciseType + (item.prodBrandName ? ` (${item.prodBrandName})` : '')}
                  className='checkbox-large'
                  onChange={() => props.toggleItem(item)}
                  checked={item.selected}
                />
                { item.specialFuel ?
                  <OverlayTrigger delay={250}
                  overlay={
                      <Tooltip id={`tooltip-card-${item.productId}`}>
                          <p style={{margin: '3px'}}>Ostuõiguse kontroll teostatakse tellimuse esitamise hetkel, selle puudumisel tellimust ei looda.</p>
                      </Tooltip>} placement={"auto"}>
                      <small className='d-flex text-danger' style={{ marginLeft: '30px' }}>
                        <i className="icon--16 icon__info--masked bg-danger d-inline-block mr-1"></i>
                        <strong>Kütuse ostmiseks on vajalik ostuõigus.</strong>
                      </small>
                      
                    </OverlayTrigger>
                    : null }
              </div>
              <div className='d-flex flex-column'>
                <div className='d-flex align-items-center'>
                  <Form.Control
                    value={item.fuelAmount}
                    disabled={!item.selected}
                    className={props.form.validated && item.invalid ? 'is-invalid' : ''}
                    type="number"
                    min={1000}
                    step={100}
                    autoComplete="off"
                    style={{ maxWidth: '192px' }}
                    onChange={(e) => changeVolume(item, e.target.value)}
                  />
                  <h5 className='ml-2 mb-0'>L</h5>
                </div>
                { props.form.validated && item.invalid ? <div className="d-block text-right invalid-feedback">Minimaalne kogus on 1000 L</div> : null }
                </div>
            </div>
          ))
        }
      </div>
    </div>
  )
}